import React from 'react';
import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CellDefaultProps } from '../../../types';
import { proposalColorStatusByTitle } from '../../../constants';

export const StatusCell = ({ proposal }: CellDefaultProps) => {
  const classes = useStyles({ bgColor: proposalColorStatusByTitle[proposal?.status] || '#ACCBEDFF' });

  return (
    <Box className={classes.container}>
      <Typography align="center" noWrap component="span" variant="body2">
        {proposal.status || 'Draft'}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { bgColor: string }>({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: '24px',
    padding: '4px 10px',
    justifyContent: 'center',
    backgroundColor: ({ bgColor }) => bgColor,
  },
});
